
    import { defineComponent } from 'vue';
    import axios, { AxiosResponse } from 'axios';
    import {  PersoConfigView, PersoConfigRequest} from "./../../Scripts/js/detecterconfig";
    export default defineComponent({
        data() {
            return {
                rowsconfigperso: [] as PersoConfigView[]
            };
        },
        props: {
            machine: Number,
            mcpersoaddinfo: String,
            mcpersoaddinfodesc:String,
            deleteconfirm: String,
            view_editperso_placeholder_name: String,
            view_editperso_placeholder_value:String
        },


        mounted() {
            if (this.machine!=null)
                this.GetPersoRows(this.machine);
            
                let self = this;
                jQuery(document).click(function (event) {
                    const $target = $(event.target);
                    if (self.IsEditPerso()) {
                        if (!$target.closest('.persoconfig input').length && !$target.closest('.persoconfig a').length && !$target.closest('.persoconfigbut').length && !$target.closest('.persoconfig .balise_titre').length && !$target.closest('.persoconfig .balise_contenu').length) {
                            self.SavePerso();
                        }
                    }
                });
            
        },
        methods: {
            GetPersoRows(machine: number) {
                let url: string = "/api/v1.0/PersoConfig/GetRows?machine=" + machine;
                let self = this;
                axios.get < PersoConfigView[] > (url).then(function (response: AxiosResponse<PersoConfigView[]>) {
                    if (response.data !== null) {
                        self.rowsconfigperso = response.data;
                    }
                });
            },
            SavePersoRows(request: PersoConfigRequest) {
                let url: string = "/api/v1.0/PersoConfig/SaveRows";
                let self = this;
                axios.post < boolean > (url, request).then(function (response: AxiosResponse<boolean>) {
                    if (response.data !== null) {

                    }
                });
            },
            AddNewConfigPerso() {
                const config: PersoConfigView = new PersoConfigView();
                config.contenu = "";
                config.titre = "";
                config.isedit = true;
                this.rowsconfigperso.push(config);

            },
            SetEditPerso(config: PersoConfigView, edit: boolean) {
                config.isedit = edit;

            },
            IsEditPerso(): boolean {
                for (const elem of this.rowsconfigperso) {
                    if (elem.isedit)
                        return true;
                }
                return false;
            },
            SavePerso(): PersoConfigView[] {
                let confperso: PersoConfigView[] = [];
                for (const elem of this.rowsconfigperso) {
                   
                    if (elem.titre != "" && elem.contenu != "") {
                        elem.isedit = false;
                        confperso.push(elem);
                    }
                }
                const request: PersoConfigRequest = new PersoConfigRequest();
                if (this.machine != null)
                request.machine = this.machine;
                request.rows = confperso;
                this.SavePersoRows(request);
               // this.rowsconfigperso = confperso;
                return confperso;

            },
            DeletePerso(index: number) {
                let choice = confirm(this.deleteconfirm);
                if (!choice)
                    return;
                if (index >= 0) {
                    this.rowsconfigperso.splice(index, 1);
                    this.SavePerso();
                }
            }
        }
    });

